import Entity from '../entity'

export default class Sale extends Entity<number>{
    sale_import_id: number;
    dealer_id: number;
    manufacturer_id: number;
    process_type_id: number;
    service_type_id: number;
    payer_id: number;
    number: number;
    plate: string;
    vin: string;
    model: string;
    city: string;
    ot: string;
    km: string;
    customer: string;
    document: string;
    cellphone: string;
    email: string;
    service_date: number;
    year: number;
    month: number;
    assessor_name: string;
    technician_name: string;
    total: number;
    notifications: number;
}


